__webpack_require__.p = "https://cdn-dev.8848top.com/project/dev/be-link-web-tools/";